import React from 'react'
import { putAwayConst } from '../../const/putAwayConst'
import { SwitchButton } from '../../../UI/SwitchButton/SwitchButton'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'

export const SwitchViewPutAway = () => {
  const { state, dispatch } = usePutAway()
  const { setViewField } = putAwayActions()
  const { optionsView } = putAwayConst()

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    field: string
  ) => {
    e.preventDefault()
    dispatch(setViewField(field))
  }

  if (state.SkuListOnPosition.length <= 0) return null

  return (
    <SwitchButton
      options={optionsView}
      isSelected={state.isSelectedFieldView}
      handleClick={handleClick}
    />
  )
}
